module.exports = __webpack_public_path__ + "static/media/fa-calendar.180c0618.svg";